/**
 * React Query hooks for app config (country/client by origin).
 */

import { useQuery } from '@tanstack/react-query';
import { getCountryByOrigin } from './app-config.service';

export const appConfigKeys = {
  all: ['appConfig'] as const,
};

/**
 * Fetches countryId and clientId from GET /v1/public/country-by-origin.
 * Backend resolves from request Origin. Critical bootstrap call — retries 3 times.
 * Not cached: always refetch when the query mounts; drop from cache when unused.
 */
export const useAppConfig = () => {
  return useQuery({
    queryKey: appConfigKeys.all,
    queryFn: getCountryByOrigin,
    staleTime: 0,
    gcTime: 0,
    retry: 3,
  });
};
